import { heroImg } from "@/mocks/chiagua";

const ticker = [
  "顶流官宣瓜持续发酵",
  "年度颁奖礼 C 位再起争议",
  "新综艺剧本传闻登上热榜",
  "代言换人内幕会员抢先看",
  "暑期档收视黑马诞生",
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 items-center gap-10 px-4 pb-14 pt-24 md:px-6 md:pb-20 lg:grid-cols-[1.05fr_0.95fr] lg:pt-32">
        <div className="w-full">
          <div className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary-500"></span>
            今日热议进行中 · 已更新 128 条
          </div>

          <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
            吃瓜福利<span className="text-primary-500">会员专享区</span>开放
            <br />
            内部资源 · 付费内容
            <span className="text-accent-600"> 一站独家解锁</span>
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            隐藏内容、独家爆料、深度整理全部聚合于此。圈内动向抢先掌握，会员可比普通访客更早看到完整瓜点与来龙去脉，不错过任何一场热度。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#join"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-transform hover:scale-[1.03] hover:bg-primary-600"
            >
              <i className="ri-vip-crown-2-line text-lg"></i>
              开通即享完整权限
            </a>
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 hover:border-primary-300 hover:text-primary-700"
            >
              先逛今日热榜
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-foreground-600">
            <span className="flex items-center gap-2">
              <i className="ri-team-line text-lg text-accent-600"></i>
              活跃社区 <b className="text-foreground-950">38.6万</b> 人
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-file-list-3-line text-lg text-accent-600"></i>
              内部资源 <b className="text-foreground-950">420+</b> 篇
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-fire-line text-lg text-primary-500"></i>
              今日热度 <b className="text-foreground-950">破 1000万</b>
            </span>
          </div>
        </div>

        <div className="w-full">
          <div className="relative mx-auto w-full max-w-[360px] lg:max-w-none">
            <img
              src={heroImg}
              alt="吃瓜福利会员专享资讯合集"
              title="吃瓜福利 会员专享资讯"
              className="aspect-[3/4] w-full rounded-2xl object-cover object-top"
            />
            <div className="absolute -left-3 top-6 flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-800 shadow-sm md:-left-6">
              <i className="ri-fire-line text-primary-500"></i> 热度榜在刷新
            </div>
            <div className="absolute -right-3 bottom-10 flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-800 shadow-sm md:-right-6">
              <i className="ri-sparkling-2-line text-accent-600"></i> 会员抢先看
            </div>
          </div>
        </div>
      </div>

      <div className="border-y border-background-200 bg-background-100 py-3">
        <div className="relative overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
            {[...ticker, ...ticker].map((t, i) => (
              <span key={i} className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-megaphone-line text-primary-500"></i>
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}